import React, { useEffect, useRef, useId } from "react";
import { Button } from "./ui/button";
export default function VerificationDialog({ title, children, onClose, busy = false, closeLabel = "Close", fullWidth = false }) {
  const ref = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);
  return (
    <dialog
      ref={ref}
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        if (!busy) onClose();
      }}
      className={`m-auto max-h-[90vh] overflow-y-auto rounded-2xl bg-white p-0 shadow-2xl backdrop:bg-slate-950/60 ${fullWidth ? 'w-full max-w-none' : 'w-[calc(100%-2rem)] max-w-3xl'}`}
    >
      <div className="flex items-center justify-between gap-4 border-b p-5">
        <h2 id={titleId} className="text-xl font-semibold">
          {title}
        </h2>
        <Button
          type="button"
          variant="ghost"
          disabled={busy}
          onClick={onClose}
          aria-label="Close dialog"
        >
          {closeLabel}
        </Button>
      </div>
      <div className="p-6">{children}</div>
    </dialog>
  );
}
